import { useGetPresentersList } from '@/hooks';
import { GetPresentersByStatus } from '@/services/api';
import { useAgentEditorStore } from '@/state/root';
import { ImageType, Presenter, PresenterUsecase } from '@d-id/types';
import { runInAction } from 'mobx';
import { useCallback } from 'react';

export function useResetAgentsSelectedPresenter(status?: GetPresentersByStatus) {
    const agentEditorStore = useAgentEditorStore();

    const { data: presenters } = useGetPresentersList({ usecase: PresenterUsecase.Agent, status });

    return useCallback(
        (options: { type: ImageType; exclude?: string }): Presenter | undefined => {
            const { type, exclude = -1 } = options;
            let chosenPresenter: Presenter | undefined;

            runInAction(() => {
                agentEditorStore.resetPresenterBackgroundSourceUrl();
                agentEditorStore.resetPresenterBackgroundThumbnailUrl();
            });

            if (presenters) {
                const filteredPresenters = presenters.filter(
                    p => p.presenterType === type && p.id !== exclude && !p.id?.includes('-removed_bg')
                );
                chosenPresenter = filteredPresenters[0];
                agentEditorStore.setSelectedPresenter(chosenPresenter?.id);
            } else {
                agentEditorStore.setSelectedPresenter('');
            }

            return chosenPresenter;
        },
        [presenters]
    );
}
